import request from '@/utils/official-request'

// 判断字符串
export function Judge(url) {
  const uel_list = '/admin/'
  if (url.includes(uel_list)) {
    return url
  } else if (url.includes('/mediate/')) {
    return url
  } else {
    const index = url.indexOf('/plaintiff/')
    if (index == -1 || index !== 0) {
      if (url.substr(0, 1) === '/') {
        return `/plaintiff${url}`
      } else {
        return `/plaintiff/${url}`
      }
    } else {
      return url
    }
  }
}

export function fetchList(url, data) {
  return request({
    url: Judge(url),
    method: 'post',
    data
  })
}
export function getaxios(url) {
  return request({
    url: Judge(url),
    method: 'get'
  })
}
export function getaxiosdata(url, query) {
  return request({
    url: Judge(url),
    method: 'get',
    params: query

  })
}
export function deleteaxios(url) {
  return request({
    url: url,
    method: 'delete'
  })
}
export function fetchArticle(id) {
  return request({
    url: '/vue-element-admin/article/detail',
    method: 'get',
    params: { id }
  })
}

export function fetchPv(pv) {
  return request({
    url: '/vue-element-admin/article/pv',
    method: 'get',
    params: { pv }
  })
}

export function createArticle(data) {
  return request({
    url: '/vue-element-admin/article/create',
    method: 'post',
    data
  })
}
export function PostData(url, data) {
  return request({
    url: Judge(url),
    method: 'post',
    data
  })
}
export function PostPut(url, data, urlobj) {
  if (urlobj) {
    url = Judge(`${url}/${urlobj}`)
  }
  return request({
    headers: { 'Content-Type': 'application/json', 'X-HTTP-Method-Override': 'PUT' },
    url: url,
    method: 'post',
    data
  })
}

export function updateArticle(data) {
  return request({
    url: '/vue-element-admin/article/update',
    method: 'post',
    data
  })
}
